const industries = [
  "Commercial Airlines",
  "Corporate Aviation",
  "Business Jet Owners",
  "Aircraft Lessors",
  "Aircraft Investors",
  "Flight Training Organisations",
  "Charter Operators",
];

export default function Industries() {
  return (
    <section data-testid="industries-section" className="py-32 md:py-40 border-t border-[#0E1B2E]/10 bg-[#F2F2EF]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8 mb-14">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3 text-[#A5854C] mb-6">
              <div className="hairline w-12"></div>
              <span className="font-mono text-[11px] uppercase tracking-[0.35em]">Industries served</span>
            </div>
            <h2 className="font-serif font-light tracking-[-0.02em] text-[#0E1B2E] text-[36px] md:text-[56px] leading-[1.02]">
              Trusted by <span className="italic text-[#A5854C]">operators,<br/> investors, financiers.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#0E1B2E]/10 border border-[#0E1B2E]/10">
          {industries.map((it, i) => (
            <div
              key={it}
              data-testid={`industry-${i}`}
              className="bg-white px-6 py-8 md:py-10 group hover:bg-[#FAFAF9] transition-colors duration-500 relative"
            >
              <div className="flex items-start justify-between">
                <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#9AA3AE]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="w-1.5 h-1.5 bg-[#C8A97E] opacity-40 group-hover:opacity-100 transition-opacity"></span>
              </div>
              <div className="mt-16 font-serif text-[20px] md:text-[24px] text-[#0E1B2E] tracking-tight leading-tight">
                {it}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
